import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import {
  defaultDoorHeight,
  defaultDoorWidth,
} from "shared/utils/doorSceneConstants";
import { PaneelGLTFResult } from "./PaneelType";

interface BeamProps {
  doorNodes: PaneelGLTFResult["nodes"];
  material: MeshPhysicalMaterial | MeshStandardMaterial;
  widthMm: number;
  doorHeightMm: number;
  centerHeightMm: number;
  offsetMm: number;
}

const PaneelBeam = ({
  doorNodes,
  material,
  widthMm,
  doorHeightMm,
  centerHeightMm,
  offsetMm,
}: BeamProps) => {
  const heightScale = doorHeightMm / defaultDoorHeight;
  const widthScale = widthMm / defaultDoorWidth;
  const beamPositionY = (centerHeightMm * heightScale + offsetMm) / 1000;

  return (
    <group>
      <mesh
        geometry={doorNodes.beam.geometry}
        material={material}
        position={[0, beamPositionY, 0]}
        scale={[widthScale, heightScale, 1]}
      />
    </group>
  );
};

export default PaneelBeam;
